export const selectNews = state => state.news;
